export function buildApiDocContext(moduleName: string) {
  return { moduleName };
}
